import { Input, SectionCard, Select } from 'components'
import { useSelector } from 'store/store'

import * as S from './styles'

export const CancelSection = () => {
  const { observation } = useSelector((state) => state.ov)

  return (
    <SectionCard
      title="Informações de cancelamento"
      tooltipText="Nesta seção você pode conferir o motivo, bem como uma descrição complementar, da razão de cancelamento da sua OV. Podendo ele ter sido, ou não, executado por você."
    >
      <S.Wrapper>
        <Select
          disabled
          label="Motivo"
          name="cancelReason"
          options={[{ title: observation.RecusaObservacao.DescricaoMotivo, value: 'reason' }]}
          required
          value={'reason'}
        />
        <div>
          <Input
            disabled
            label="Descrição"
            name="cancelDescription"
            required
            rows={3}
            value={observation.RecusaObservacao.Comentarios}
          />
        </div>
      </S.Wrapper>
    </SectionCard>
  )
}
